import React, { FC, SVGProps } from 'react';

export const TaxEfficient: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="#B1CB8F" />
    <circle
      cx="50"
      cy="50"
      r="7"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
    />
    <path
      d="M26 54L54 26"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="30" cy="30" r="7" stroke="#26313B" strokeWidth="2" />
  </svg>
);
